import { render } from "./Pending.vue?vue&type=template&id=6fb4c893"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"
script.render = render

export default script